module.exports = __webpack_public_path__ + "img/seafoodBG.e5edffc0.jpg";